
import { defineComponent, PropType } from "vue";

export default defineComponent({
  name: "BtnDefault",
  components: {},
  props: {
    mode: {
      type: String as PropType<"default" | "icon" | "item">,
      default: "default",
    },
    btnProps: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    btnPropsComputed(): any {
      return {
        noCaps: true,
        class: undefined,
        style: undefined,
        tooltip: undefined,
        label: undefined,
        ...this.modeProps[this.mode],
        ...this.btnProps,
      };
    },
  },
  data() {
    return {
      modeProps: {
        default: {
          unelevated: true,
          label: "default label",
        },
        icon: {
          flat: true,
          icon: "tag",
          tooltip: "icon tooltip",
          dense: true,
        },
        item: {
          flat: true,
          label: "item label",
          dense: false,
          class: "full-width",
          align: "left",
        },
      },
    };
  },
  watch: {},
  methods: {},
});
